import { FC, SVGProps } from 'react';

export const RewardIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      id="rewards-icon"
      {...props}
    >
      <path
        d="M32.9167 12.4688H7.08333C6.62333 12.4688 6.25 12.8421 6.25 13.3021V19.1354C6.25 19.5954 6.62333 19.9688 7.08333 19.9688H7.91667V31.6354C7.91667 33.9362 9.7825 35.8021 12.0833 35.8021H27.9167C30.2175 35.8021 32.0833 33.9362 32.0833 31.6354V19.9688H32.9167C33.3767 19.9688 33.75 19.5954 33.75 19.1354V13.3021C33.75 12.8413 33.3767 12.4688 32.9167 12.4688Z"
        fill="url(#reward-gradient)"
      />
      <path
        d="M23.4925 19.5781H7.08333C6.62333 19.5781 6.25 19.2048 6.25 18.7448V12.9115C6.25 12.4515 6.62333 12.0781 7.08333 12.0781H32.9167C33.3767 12.0781 33.75 12.4515 33.75 12.9115V18.7448C33.75 19.2048 33.3767 19.5781 32.9167 19.5781H27.9342"
        stroke="var(--color-main-0)"
      />
      <path
        d="M32.0807 19.5781V31.2448C32.0807 33.5456 30.2149 35.4115 27.9141 35.4115H12.0807C9.7799 35.4115 7.91406 33.5456 7.91406 31.2448V24.6048"
        stroke="var(--color-main-0)"
      />
      <path
        d="M15.8307 12.0833C13.5299 12.0833 11.6641 10.2175 11.6641 7.91667C11.6641 5.61583 13.5299 3.75 15.8307 3.75C18.1316 3.75 19.9974 5.61583 19.9974 7.91667"
        stroke="var(--color-main-0)"
      />
      <path
        d="M20 7.91667C20 5.61583 21.8658 3.75 24.1667 3.75C26.4675 3.75 28.3333 5.61583 28.3333 7.91667C28.3333 10.2175 26.4675 12.0833 24.1667 12.0833"
        stroke="var(--color-main-0)"
      />
      <path d="M20 35.4167V7.5" stroke="var(--color-main-0)" />
    </svg>
  );
};
